import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MagentoCmsPage } from 'lib/types'
import { Slice } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: []
}

const slice = createSlice({
  name: 'common/pageList',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<MagentoCmsPage[]>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchPageList (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().cms.fetchPageList()
      const { data } = response.data || {}
      const { getCmsPages } = data || {}

      if (getCmsPages) {
        dispatch(success(getCmsPages.items))
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
